/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tabs_Overview1Inputs */

const id_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikhtisar`)
};

const ms_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambaran Keseluruhan`)
};

const da_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversigt`)
};

const de_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const en_us2_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_es2_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const es_mx2_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const fil_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalahatang-ideya`)
};

const fr_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const it_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const hu_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áttekintés`)
};

const nl_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

const no_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversikt`)
};

const pl_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const pt_br2_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const pt_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const ro_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentare generală`)
};

const fi_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiskatsaus`)
};

const sv_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Översikt`)
};

const vi_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan`)
};

const tr_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel Bakış`)
};

const cs_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled`)
};

const bg_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ преглед`)
};

const ru_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const uk_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const ar_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة`)
};

const hi_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवलोकन`)
};

const th_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพรวม`)
};

const ja_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_cn2_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

const zh_hant1_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概覽`)
};

const ko_offerdetail_tabs_overview1 = /** @type {(inputs: Offerdetail_Tabs_Overview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개요`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Offerdetail_Tabs_Overview1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tabs_overview1 = /** @type {((inputs?: Offerdetail_Tabs_Overview1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tabs_Overview1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tabs_overview1(inputs)
	if (locale === "ms") return ms_offerdetail_tabs_overview1(inputs)
	if (locale === "da") return da_offerdetail_tabs_overview1(inputs)
	if (locale === "de") return de_offerdetail_tabs_overview1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tabs_overview1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tabs_overview1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tabs_overview1(inputs)
	if (locale === "fil") return fil_offerdetail_tabs_overview1(inputs)
	if (locale === "fr") return fr_offerdetail_tabs_overview1(inputs)
	if (locale === "it") return it_offerdetail_tabs_overview1(inputs)
	if (locale === "hu") return hu_offerdetail_tabs_overview1(inputs)
	if (locale === "nl") return nl_offerdetail_tabs_overview1(inputs)
	if (locale === "no") return no_offerdetail_tabs_overview1(inputs)
	if (locale === "pl") return pl_offerdetail_tabs_overview1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tabs_overview1(inputs)
	if (locale === "pt") return pt_offerdetail_tabs_overview1(inputs)
	if (locale === "ro") return ro_offerdetail_tabs_overview1(inputs)
	if (locale === "fi") return fi_offerdetail_tabs_overview1(inputs)
	if (locale === "sv") return sv_offerdetail_tabs_overview1(inputs)
	if (locale === "vi") return vi_offerdetail_tabs_overview1(inputs)
	if (locale === "tr") return tr_offerdetail_tabs_overview1(inputs)
	if (locale === "cs") return cs_offerdetail_tabs_overview1(inputs)
	if (locale === "bg") return bg_offerdetail_tabs_overview1(inputs)
	if (locale === "ru") return ru_offerdetail_tabs_overview1(inputs)
	if (locale === "uk") return uk_offerdetail_tabs_overview1(inputs)
	if (locale === "ar") return ar_offerdetail_tabs_overview1(inputs)
	if (locale === "hi") return hi_offerdetail_tabs_overview1(inputs)
	if (locale === "th") return th_offerdetail_tabs_overview1(inputs)
	if (locale === "ja") return ja_offerdetail_tabs_overview1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tabs_overview1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tabs_overview1(inputs)
	return ko_offerdetail_tabs_overview1(inputs)
});
export { offerdetail_tabs_overview1 as "offerDetail.tabs.overview" }